import Quill from 'quill';
import randomColor from 'randomcolor';

const Embed = Quill.import('blots/embed');

const BASE_COLORS = ['blue', 'red', '#14BB8C'];
const rt_field_color_map = {};
class EmBlot extends Embed {
  static create(attrs) {
    const { value, id, isOpen, isClose } = attrs;
    const node = super.create(attrs);
    node.setAttribute('data-id', id);
    node.setAttribute('contenteditable', false);
    node.setAttribute('isOpen', isOpen);
    node.setAttribute('isClose', isClose);
    node.setAttribute('role', 'field-embed');

    // 禁止拖拽
    node.ondragstart = function (event) {
      event.preventDefault();
    };
    node.ondragover = function (event) {
      event.preventDefault();
    };
    // 禁止复制
    // node.addEventListener('copy', (e) => {
    //   navigator.clipboard.writeText('');
    //   e.preventDefault();
    // });

    // 随机色处理
    let baseColor = BASE_COLORS[Math.floor(Math.random() * BASE_COLORS.length)];
    if (rt_field_color_map[id]) {
      baseColor = rt_field_color_map[id];
    } else {
      rt_field_color_map[id] = baseColor;
    }
    const color = randomColor({
      luminosity: 'light',
      hue: baseColor,
      seed: id,
    });

    // 不用background,因为background会参与quill中embed计算，导致各种异常
    node.style.boxShadow = `inset 10em 10em ${color}`;
    // 这里是为了做箭头的颜色同步
    node.style.borderColor = color;
    node.innerText = value ?? '';
    return node;
  }

  static formats(node) {
    const id = node.getAttribute('data-id');
    return {
      id,
      value: node.innerText,
      isOpen: node.getAttribute('isOpen'),
      isClose: node.getAttribute('isClose'),
    };
  }
}

EmBlot.blotName = 'DotFieldEmbed';
EmBlot.className = 'ql-field-embed-string';
EmBlot.tagName = 'em';

export default EmBlot;
